/* eslint-disable import/no-default-export */
import classNames from 'classnames';
import React from 'react';

import Atom from './atom';
import styles from './power-up.less';
import { DescriptionAtomProps } from './types';

export const DescriptionAtom: React.FunctionComponent<DescriptionAtomProps> = ({
  className,
  overview,
  ...props
}) => (
  <div className={classNames(styles.flexColumn, className)}>
    <Atom {...props} />
    <span className={styles.description}>{overview}</span>
  </div>
);

export const StyledDescriptionAtom: React.FunctionComponent<
  DescriptionAtomProps
> = ({ className, ...props }) => (
  <DescriptionAtom
    className={classNames(styles.descriptionAtom, className)}
    {...props}
  />
);

export default StyledDescriptionAtom;
